import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { Triage, triageConstants } from '../types/triage.types';
 
const entityConstants = triageConstants
 
const fetchTriage = async (onlyActive = false): Promise<Triage[]> => {
	const response = await api.get(`${entityConstants.apiEndpoint}/${onlyActive ? 'activo' : ''}`);
	return response?.data?.triage;
};
 
export const useTriage = (onlyActive = false) => {
	return useQuery<Triage[], Error>({
		queryKey: [entityConstants.entityLabel.toLowerCase()],
		queryFn: () => fetchTriage(onlyActive),
		// staleTime: 5 * 60 * 1000,
		enabled: true,
	});
};